import React, {useState} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";

interface ConfiguationNameUpdateDialogProps {
  open: boolean;
  initialName: string;
  onClose: () => void;
  onDuplicate: (name: string) => void;
}

const ConfigurationDuplicateDialog: React.FC<ConfiguationNameUpdateDialogProps> = ({
  open,
  initialName,
  onClose,
  onDuplicate,
}) => {
  const [name, setName] = useState<string>(initialName);

  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={onClose}>
      <DialogTitle>Duplicate Configuration</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will create a new configuration, with no history.
        </DialogContentText>
        <TextField
          fullWidth
          label="name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={name === initialName || name.length === 0}
          onClick={() => {
            onDuplicate(name);
          }}
        >
          Duplicate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigurationDuplicateDialog;
